import { RedoShopifyOrderCancelReason } from "@redotech/redo-fulfillment-group-common/order-cancel-reason";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { productBinCountsSchema } from "./cancel-order-items";

export const GENERIC_CANCEL_ORDER_ERROR_MESSAGE =
  "An error occurred while canceling this order. Please try again or contact support.";

const shopifyCancelOrderErrorMessages: readonly [RegExp, string][] = [
  [
    /^Shopify orderCancel failed for order .+?: INVALID: orderId - Cannot cancel an order that has outstanding fulfillments$/,
    "Shopify couldn't cancel this order because one or more of its fulfillments can't be canceled. Review the order's fulfillments in Shopify, then try again.",
  ],
  [
    /^Shopify orderCancel failed for order .+?: INVALID: orderId - Cannot cancel an order that has already been cancell?ed$/,
    "This order is already canceled in Shopify.",
  ],
  [
    /^Shopify orderCancel failed for order .+?: INVALID: orderId - Cannot cancel an order that has returns$/,
    "Shopify couldn't cancel this order because it has a return in progress. Close or cancel the return, then try again.",
  ],
];

export const USER_FACING_CANCEL_ORDER_ERROR_MESSAGES: ReadonlySet<string> =
  new Set(shopifyCancelOrderErrorMessages.map(([, message]) => message));

export function getUserFacingCancelOrderErrorMessage(message: string): string {
  return (
    shopifyCancelOrderErrorMessages.find(([pattern]) =>
      pattern.test(message),
    )?.[1] ?? GENERIC_CANCEL_ORDER_ERROR_MESSAGE
  );
}

export const cancelFulfillmentGroups = {
  name: "cancelFulfillmentGroups" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(zExt.objectId()),
    reason: createEnum(RedoShopifyOrderCancelReason).nullish(),
    notifyCustomer: z.boolean().nullish(),
    refund: z.boolean().nullish(),
    restock: z.boolean().nullish(),
    /** WMS source of truth: bins to set to a counted quantity after the cancel, one entry per product. */
    productBinCounts: z.array(productBinCountsSchema).nullish(),
  }),
  output: z.null(),
};
